"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamSSOTypesEnum = exports.TeamsRoles = void 0;
// Define the team_roles_enum enum type
var TeamsRoles;
(function (TeamsRoles) {
    TeamsRoles["Admin"] = "admin";
    TeamsRoles["Editor"] = "editor";
    TeamsRoles["Readonly"] = "readonly";
})(TeamsRoles = exports.TeamsRoles || (exports.TeamsRoles = {}));
// Define the team_sso_types_enum enum type
var TeamSSOTypesEnum;
(function (TeamSSOTypesEnum) {
    TeamSSOTypesEnum["Microsoft"] = "microsoft";
    TeamSSOTypesEnum["Apple"] = "apple";
    TeamSSOTypesEnum["GitHub"] = "github";
    TeamSSOTypesEnum["Google"] = "google";
    TeamSSOTypesEnum["Twitter"] = "twitter";
})(TeamSSOTypesEnum = exports.TeamSSOTypesEnum || (exports.TeamSSOTypesEnum = {}));
